import { Injectable, signal } from '@angular/core';
import { LangProvider } from '../lang/lang';

export type SupportedLang = 'IT' | 'EN' | 'FR' | 'NL' | 'DE';

@Injectable({ providedIn: 'root' })
export class TranslationService {
  readonly currentLang = signal<SupportedLang>('IT');

  constructor(private lingua: LangProvider) {
    // Sync signal when LangProvider finishes loading
    this.lingua.translationsLoaded.then(() => {
      const lang = this.lingua.languageSelected?.toUpperCase() as SupportedLang;
      if (lang) this.currentLang.set(lang);
    });
    // cambio lingua senza riavvio
    this.lingua.linguaCambiata$.subscribe(lang => this.currentLang.set(lang as SupportedLang));
  }

  /**
   * Restituisce la traduzione per la chiave data.
   * Priorità: JSON della lingua corrente → italiano (nel bundle, vedi LangProvider) → chiave stessa
   */
  t(key: string, params?: Record<string, string | number>): string {
    this.currentLang();  // chi legge t() dentro un computed o un effect si riaggiorna al cambio lingua
    let value = this.lingua.getTranslation(key) ?? key;

    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        value = value.replace(new RegExp(`\\{\\{${k}\\}\\}`, 'g'), String(v));
      });
    }

    return value;
  }
}
